export const TRACKER = {
    MEMBERSELECT_CONTENT: 'MEMBERSELECT_CONTENT',
    // 快捷填充 - 点击
    PLUGIN_QUICK_FILL_CLICK: 'plugin_quick_fill_click',
    // 快捷填充 - 成功
    PLUGIN_QUICK_FILL_SUCCESS: 'plugin_quick_fill_success',
    // 快捷填充 - 保留
    PLUGIN_QUICK_FILL_RESERVE: 'plugin_quick_fill_reserve',
    // 快捷填充 - discard
    PLUGIN_QUICK_FILL_REJECT: 'plugin_quick_fill_reject',
    // 查看帮助文档
    PLUGIN_USAGE_LEARN: 'plugin_usage_learn',
    // 手动填充
    PLUGIN_QUICK_FILL_MANUAL_SET: 'plugin_quick_fill_manual_set',
    /** 插件配置-选择配置 */
    PLUGIN_CONFIG_SELECT: 'plugin_config_select'
};
